import { render, staticRenderFns } from "./photo2.vue?vue&type=template&id=0ac9d090&scoped=true&"
import script from "./photo2.vue?vue&type=script&lang=js&"
export * from "./photo2.vue?vue&type=script&lang=js&"
import style0 from "./photo2.vue?vue&type=style&index=0&id=0ac9d090&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac9d090",
  null
  
)

export default component.exports